import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient(
  import.meta.env.VITE_API_URL ? { baseURL: import.meta.env.VITE_API_URL } : {}
)
